import { Injectable, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ServerConn } from '../_services/serverConn.service';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  data: any[] = [];
  pending: any[] = [];
  length = 0;
  lact: any[] = [];
  needUpdate: EventEmitter<any> = new EventEmitter();
  selectedCEA = '';

  constructor(private server: ServerConn) { }

  get(force = false, search = '', tblstart = 0, tbllimit = 0, tblorder = ''): Observable<any> {
    if (!this.data.length || force) {
      return this.server.get(
        'orders',
        {
          search: search,
          tblstart: tblstart,
          tbllimit: tbllimit,
          tblorder: tblorder,
        }
      )
        .pipe(
          tap(
            (res: any) => {
              const data = (typeof res.json !== 'undefined') ? res.json() : res;
              this.data = data.data;
              console.log('🚀 ~ file: almacen.service.ts ~ line 35 ~ AlmacenService ~ get ~ data.data', data.data);
            }
          )
        );
    } else {
      return of({
        result: true,
        data: this.data
      });
    }
  }

  getById(id): Observable<any> {
    /**
     * Retornamos una orden
     */
    return this.server.get(
      'orders/' + id
    )
      .pipe(
        tap(
          res => {
            if (res.result) {
              this.data = res.data;
            }
          }
        )
      );
  }

  getPortes(data) {
    return this.server.post(
      'orders/getportes',
      {
        d: JSON.stringify(data)
      }
    );
  }

  save(data) {
    return this.server.post(
      'orders/save',
      {
        d: JSON.stringify(data)
      }
    );
  }

  /* 
  * Elimina uno o varios pedidos
  */
  delete(idorder : number | number[]) {
    return this.server.post(
      'orders/delete',
      {
        r: JSON.stringify(idorder)
      }
    );
  }

  /* 
  * Elimina uno o varios productos de un pedido
  */
  deleteProducts(ids: number[]) {
    // Concatenar los IDs con coma para eliminar múltiples
    const idsString = ids.join(',');
    return this.server.post(
      'orders/delete?t=pedidos_detalle&r=' + idsString
    );
  }

}
